"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var _globalTokens = require("../../../shared/global-tokens");
var _icon = require("../../media/icon/icon.tokens");
var tokens = exports.tokens = {
  font: {
    standard: "\n\t\t\t\tfont-family: ".concat(_globalTokens.typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(_globalTokens.typeface.weight.content.regular, ";\n \n\t\t\t\tfont-size: ").concat(_globalTokens.typeScale.fontSize['4'], ";\n \n\t\t\t\tletter-spacing: ").concat(_globalTokens.typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(_globalTokens.typeScale.lineHeight['4'], ";\n\n\t\t\t\t")
  },
  color: {
    font: {
      default: _globalTokens.globalColor.text.content.main,
      checked: _globalTokens.globalColor.text.content.onDark,
      hover: _globalTokens.globalColor.text.content.main,
      disabled: _globalTokens.globalColor.text.disabled.onDisabled
    },
    background: {
      default: _globalTokens.globalColor.background.neutral['1'],
      checked: _globalTokens.globalColor.background.secondary['3'],
      hover: _globalTokens.globalColor.background.secondary['1'],
      disabled: _globalTokens.globalColor.background.disabled
    },
    icon: {
      default: _icon.tokens.color.default,
      checked: _icon.tokens.color.white,
      hover: _icon.tokens.color.default,
      disabled: _icon.tokens.color.disabled
    },
    border: {
      default: _globalTokens.globalColor.border.separator,
      checked: _globalTokens.globalColor.border.active,
      hover: _globalTokens.globalColor.border.separator,
      disabled: _globalTokens.globalColor.border.disabled,
      error: _globalTokens.globalColor.border.error
    }
  },
  size: {
    height: '44px'
  },
  focusRing: "".concat(_globalTokens.globalShadow.focusRingLight)
};